export const PRIVACY_POLICY_HTML = `<p style="margin-bottom:1px;"><strong style="font-weight:500;font-size:14px;">TrueTenant Inc. &ndash; Privacy Policy</strong></p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">Last Updated:</strong><span style="font-weight: 400;color:#32302F; font-size:14px;"> October 8, 2025</span></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant is committed to safeguarding personal information in accordance with applicable Canadian privacy laws.
        This Privacy Policy describes how we collect, use, store, disclose, and protect your personal information.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">1. INTRODUCTION</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >This Privacy Policy (&ldquo;Policy&rdquo;) describes how TrueTenant Inc. (&ldquo;TrueTenant,&rdquo; &ldquo;we,&rdquo;
        &ldquo;our,&rdquo; or &ldquo;us&rdquo;) collects, uses, stores, discloses, and protects your personal information
        in connection with our tenant screening, reusable tenant profile, property management and related services (the
        &ldquo;Services&rdquo;). We are committed to safeguarding personal information in accordance with applicable
        Canadian privacy laws.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >By creating an account and reusable tenant profile (&ldquo;Profile&rdquo;) with TrueTenant, you acknowledge that
        we will collect, retain, and use your personal information as described in this Policy. Consent to this
        collection and retention is a mandatory condition for using the Services. If you do not consent to these
        practices, you must not create or maintain a Profile.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">2. DEFINITIONS</strong></p>
<p style="margin-bottom:15px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">For the purposes of this Policy:</span></p>
<ul style="list-style-type:disc;padding-left:24px;">
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:8px;">
        <strong style="font-weight:500;font-size:14px;">&ldquo;Personal Information&rdquo;</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            means information about an identifiable individual, as defined under applicable Canadian privacy laws. This
            includes any information that can identify you directly or indirectly (for example, your name, address, date
            of birth, contact information, identification numbers, etc.).</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">&ldquo;Profile&rdquo;</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            means the reusable tenant profile created and maintained on the TrueTenant platform, including the TrueTenant
            Score and all related data about a User.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">&ldquo;User&rdquo;</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            means any individual who creates a Profile on the TrueTenant platform (also referred to as &ldquo;you&rdquo;
            in this Policy).</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">&ldquo;Landlord&rdquo; or &ldquo;Property Manager&rdquo;</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            means a third party to whom a User&rsquo;s data may be disclosed via the Services for the purpose of
            evaluating rental applications.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">&ldquo;Services&rdquo;</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            refers to the tenant screening, Profile management, property management, and related services and
            applications provided by TrueTenant.</span
        >
    </li>
</ul>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">3. INFORMATION COLLECTED</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant may collect and process the following categories of Personal Information from Users:</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">3.1 Identity and Contact Information</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >This includes your full name, date of birth, current address, email address, phone number, government-issued
        identification details (e.g. driver&rsquo;s license or passport number), biometric photographs or video for
        identity verification, residency or citizenship status, and any related verification data.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">3.2 Financial Information</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Information used to assess creditworthiness and income, such as credit reports and scores obtained from credit
        bureaus (e.g. Equifax), banking and income data obtained via services like Flinks (account balances, transaction
        history, employment income), tax documents (T4 slips, Notices of Assessment), and other financial records
        relevant to rental applications.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">3.3 Rental History</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Your current and past rental information, including references from previous landlords or property managers,
        records of rent payment history, any eviction records or tenancy tribunal findings (e.g. LTB or CanLII records
        in Canada), and related tenancy data.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">3.4 Background Information</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Results of background checks such as criminal record checks, court records search, OpenRoom verification
        (rental-history data), and other screening databases or watch-lists as permitted by law.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">3.5 Guarantor Information</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If you provide a guarantor for your lease, we collect similar identity and financial information about that
        guarantor (with their consent), such as their name, contact details, identification, credit and income
        verification data, for the purpose of linking them to your Profile.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">3.6 System and Usage Data</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Technical information related to your use of the platform and Services. This includes device identifiers, IP
        addresses, cookie identifiers, browser type, operating system, access times, and activity logs. We collect this
        data to monitor system performance, maintain security (e.g. detecting fraud or unauthorized access), and improve
        user experience. Cookies and similar technologies may be used to remember your preferences and track usage
        analytics. You can manage cookie preferences through your browser settings.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">4. PURPOSES OF COLLECTION AND USE</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant collects and uses Personal Information for the following purposes, and will not use it for other
        purposes without your consent or as required/permitted by law:</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">a. Profile Creation and Reuse</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >To establish, maintain, and update your reusable tenant Profile, including calculating and updating your
        TrueTenant Score. This allows you to re-use your verified information for multiple rental applications without
        needing to re-submit data each time.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">b. Tenant Screening Services</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >To provide tenant screening reports and Profile data to Landlords/Property Managers that you choose to apply or
        submit your Profile to, so they can evaluate your rental applications quickly and objectively.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">c. Identity Verification and Fraud Prevention</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >To verify your identity (for example, through biometric matching of your ID photo) and to detect and prevent
        fraud, impersonation, or other unauthorized activities on the platform.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">d. Lease and Property Management</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >To facilitate rental transactions and tenancy management, such as assisting with lease agreements, rent payment
        processing, maintenance requests, renewals, and other property management functions related to any tenancy you
        enter via our platform.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">e. Service Improvement and Analytics</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >To improve and develop our Services. This includes using Personal Information (in identified or anonymized form)
        to train and refine TrueTenant&rsquo;s AI-driven analytics and scoring algorithms, to conduct research and
        analytics about our user base and service usage, and to enhance user experience and security.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">f. Alternative Housing Offers (With Consent)</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >With your explicit opt-in consent, to present you with or refer you to alternative rental housing options or
        related services in cases where you may not qualify for a specific property. This will only be done if you agree
        to such use of your Profile for finding other opportunities.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">g. Communications and Customer Support</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >To communicate with you about your account and the Services. For example, we use your contact information to send
        account confirmations, application status updates, responses to your inquiries or support requests, and updates
        about new features or policy changes.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">h. Legal Obligations and Enforcement</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >To comply with our legal and regulatory obligations (for instance, privacy laws, credit reporting rules, or
        court orders) and to enforce our agreements and defend our legal rights. This includes using or disclosing
        information as required to cooperate with regulators, to resolve disputes, or to address violations of law or our
        Terms of Service.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">5. CONSENT AND PROFILE RETENTION</strong></p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">5.1 Mandatory Consent</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Your consent to the collection, retention, and use of your Personal Information for creating and maintaining a
        reusable tenant Profile is a mandatory condition for using the Services. In other words, you cannot create or
        maintain a Profile without agreeing to this ongoing use of your information. We will only collect and use
        information that is necessary for the purposes outlined in this Policy and as allowed by law.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">5.2 Profile Reuse</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Once created, your Profile (and TrueTenant Score) can be re-used to apply for multiple rental properties without
        requiring you to undergo repeated screenings. This reuse is always subject to your ongoing consent. You control
        which Landlords/Property Managers can view your Profile when you choose to apply to their listings.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">5.3 Withdrawal of Consent</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >You have the right to withdraw your consent at any time. You may do so by deactivating your Profile in your
        account settings or contacting us to request deletion. Upon withdrawal of consent, TrueTenant will delete your
        Profile and associated Personal Information, subject to the retention provisions in Section 6 below.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Please note that withdrawing consent will mean we can no longer provide you with the Services (since we cannot
        maintain your Profile). Any pending rental applications through TrueTenant may be cancelled if you withdraw
        consent before they are completed. TrueTenant will also inform any third parties who received your data (such as
        a prospective landlord) of your withdrawal if appropriate.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Note: In certain cases, Canadian law allows or requires us to collect, use, or retain personal information
        without consent (for example, to investigate fraud or as required by a subpoena). This Policy does not limit any
        such legal exceptions.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">6. DATA RETENTION</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant retains Personal Information only for as long as necessary to fulfill the purposes described in this
        Policy or as required by law. Our retention practices are as follows:</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">6.1 Retention of an Active Profile</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >To provide the core benefit of a reusable Profile, we retain your Personal Information for as long as you choose
        to maintain an active account with us. An account is considered active as long as you periodically log in. If an
        account has no login activity for a continuous period of thirty-six (36) months, it will be deemed inactive.
        Prior to taking any action, we will notify you via the email address on file, providing you with an opportunity
        to keep your account active.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">6.2 Retention During and After an Active Tenancy</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If a User&rsquo;s rental application is successful and they become a tenant, we will retain the User&rsquo;s
        Profile and related Personal Information for the duration of that tenancy and for up to two (2) years after the
        tenancy ends. This specific retention period is necessary for handling potential dispute resolution, providing
        landlord references, and meeting legal or regulatory requirements that may arise from the tenancy.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">6.3 Anonymized Data</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant may retain data that has been anonymized or aggregated (i.e., it can no longer be associated with you
        personally) indefinitely. We use such anonymized data for statistical analysis, service improvements, and
        business planning and development.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">6.4 Legal and Compliance Retention</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Notwithstanding the above, TrueTenant may retain certain Personal Information for longer periods if required to
        comply with applicable laws, regulations, or legitimate business obligations. For example, we may need to keep
        records to resolve legal claims or comply with financial reporting laws.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">6.5 Deletion and Disposal</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Once Personal Information is no longer required for the purposes stated above, TrueTenant will permanently erase,
        delete, or anonymize the information in a secure manner. When you request the deletion of your Profile, we will
        delete all information not subject to a required legal or compliance retention period.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">7. DISCLOSURE OF INFORMATION</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant will disclose your Personal Information to third parties only in the following circumstances, and
        always in accordance with this Policy and applicable law:</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">a. To Landlords/Property Managers (User-Initiated)</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >We share your Profile information with a Landlord or Property Manager only when you choose to apply to a rental
        property or otherwise direct us to do so. TrueTenant contractually requires Landlords/Property Managers using our
        platform to handle your information in compliance with privacy laws and to refrain from harassment or any misuse
        of your data.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">b. To Guarantors Authorized by You</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If you designate a guarantor or co-signer in your Profile, we may share necessary information with that guarantor
        (and collect information from them) for the purpose of linking them to your application obligation. This occurs
        only with your involvement and the guarantor&rsquo;s consent.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">c. To Third-Party Service Providers</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >We disclose relevant Personal Information to trusted third-party service providers who perform services on our
        behalf. This includes credit bureaus (e.g. Equifax), financial aggregators (e.g. Flinks), identity verification
        services, payment processors, cloud storage or IT service providers, and background check agencies. These third
        parties are contractually obligated to protect your Personal Information and use it solely for the purposes we
        specify.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">d. For Legal or Regulatory Compliance</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >We may disclose Personal Information to government, regulatory, or judicial authorities as required by law. We
        will also disclose information as necessary to protect the rights, property, or safety of TrueTenant, our users,
        or the public.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">e. Business Transfers</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If TrueTenant is involved in a business transaction such as a merger, acquisition, or sale of assets, Personal
        Information may be disclosed to the successors or assigns. We will ensure your Personal Information remains
        subject to confidentiality obligations and will provide notice before Personal Information is transferred.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">f. Advertising and Referral Partners (With Consent)</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant may offer programs or partnerships that involve sharing your information with third parties for
        advertising, referral, or promotional purposes only if you provide explicit consent. You have the choice to
        participate in or decline any such program.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">No Sale of Personal Information:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        We do not sell, rent, or disclose your Personal Information to third parties for their own marketing or
        commercial uses without your consent. TrueTenant&rsquo;s disclosures are limited to the purposes listed
        above.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">8. USER RIGHTS</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Subject to applicable laws, individuals using TrueTenant have the following rights regarding their Personal
        Information:</span
    >
</p>
<ul style="list-style-type:none;padding-left:0;">
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:8px;">
        <span style="color:#16a34a;font-weight:700;font-size:14px;">&#10003;</span>
        <strong style="font-weight:500;font-size:14px;">Access Your Information:</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            You have the right to access the Personal Information that TrueTenant holds about you. We will provide you
            with a copy or description, typically within 30 days.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:8px;">
        <span style="color:#16a34a;font-weight:700;font-size:14px;">&#10003;</span>
        <strong style="font-weight:500;font-size:14px;">Corrections and Updates:</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            If any of your Personal Information is inaccurate or incomplete, you have the right to request a correction or
            update.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:8px;">
        <span style="color:#16a34a;font-weight:700;font-size:14px;">&#10003;</span>
        <strong style="font-weight:500;font-size:14px;">Deletion (&ldquo;Right to be Forgotten&rdquo;):</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            You may request deletion of your Profile and associated Personal Information from TrueTenant&rsquo;s
            systems.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:8px;">
        <span style="color:#16a34a;font-weight:700;font-size:14px;">&#10003;</span>
        <strong style="font-weight:500;font-size:14px;">Withdraw Consent:</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            You have the right to withdraw your consent to our continued use or retention of your Personal
            Information.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:8px;">
        <span style="color:#16a34a;font-weight:700;font-size:14px;">&#10003;</span>
        <strong style="font-weight:500;font-size:14px;">Data Portability:</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            You have the right to obtain a copy of your reusable tenant Profile in a portable, machine-readable
            format.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:8px;">
        <span style="color:#16a34a;font-weight:700;font-size:14px;">&#10003;</span>
        <strong style="font-weight:500;font-size:14px;">File Complaints:</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            You have the right to file a complaint with the Office of the Privacy Commissioner of Canada or your
            provincial privacy commissioner.</span
        >
    </li>
</ul>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">Exercising Your Rights:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        You can exercise many of the above rights directly through the TrueTenant platform. For any requests or
        questions, contact our Privacy Officer (see Section 16). TrueTenant will respond to legitimate requests within 30
        days under PIPEDA.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">9. SECURITY MEASURES</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant takes the security of Personal Information very seriously and implements reasonable and appropriate
        technical, physical, and organizational safeguards to protect against unauthorized access, disclosure, or loss
        of your data. These measures include:</span
    >
</p>
<ul>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">Encryption:</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            Strong encryption protocols protect Personal Information during transmission and storage.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">Identity Verification:</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            Biometric identity verification and AI-driven fraud detection tools prevent unauthorized access.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">Access Controls:</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            Strict access controls ensure only authorized personnel can access information on a need-to-know basis.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">Employee Training:</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            All staff are trained on their responsibilities to protect Personal Information.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">Security Audits:</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">
            Regular audits and tests identify and address potential vulnerabilities.</span
        >
    </li>
</ul>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">Note:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        Despite our robust safeguards, no method of transmission over the Internet is 100% secure. In the unlikely event
        of a security breach, we have put in place a response plan (see Section 10).</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">10. DATA BREACH NOTIFICATION</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant has implemented a Data Breach Response Plan. In the event of a breach involving loss, theft, or
        unauthorized access to Personal Information that poses a &ldquo;real risk of significant harm&rdquo; to any
        individual, TrueTenant will:</span
    >
</p>
<ul style="list-style-type:disc;padding-left:24px;">
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:4px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">Contain and investigate the breach;</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:4px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">Assess the risk of harm;</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:4px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;"
            >Notify the federal Privacy Commissioner of Canada (and any relevant provincial regulators) as soon as
            feasible;</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:4px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;"
            >Notify all individuals whose information was involved and who may be at risk; and</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;margin-bottom:4px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">Keep a record of all data breaches as required by law.</span>
    </li>
</ul>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">11. INTERNATIONAL DATA TRANSFERS</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant is based in Canada, but the Personal Information we collect may be stored or processed on servers
        located outside of Canada, including in the United States. When we transfer or store Personal Information in
        another country, we will implement contractual and technical safeguards to ensure it receives a level of
        protection comparable to that provided under Canadian privacy laws.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Be aware that Personal Information stored outside Canada may be subject to the laws of that country and may be
        accessible to foreign courts, law enforcement and national security authorities in those jurisdictions.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">12. CHILDREN&rsquo;S PRIVACY</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >The Services are not directed to individuals under the age of eighteen (18), and we do not knowingly solicit or
        collect Personal Information from minors. If we become aware that a person under 18 has provided us with Personal
        Information, we will take immediate steps to delete that information.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">13. POLICY UPDATES</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant reserves the right to amend or update this Privacy Policy. If any changes are material, we will
        provide a prominent notice to Users, such as by email or an in-app alert. Your continued use of the Services
        after any updated Policy has become effective will signify your acceptance of the changes.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">14. CANADA-WIDE COMPLIANCE</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant&rsquo;s Personal Information handling practices are designed to meet or exceed the requirements of
        privacy laws across Canada.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">14.1 Federal Law (PIPEDA):</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        This Policy is governed by the federal Personal Information Protection and Electronic Documents Act
        (&ldquo;PIPEDA&rdquo;). We uphold the ten Fair Information Principles of PIPEDA. TrueTenant has appointed a
        Privacy Officer responsible for overseeing our compliance.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">14.2 Provincial Private-Sector Privacy Laws:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        In provinces with their own private-sector privacy laws (Alberta, British Columbia, and Qu&eacute;bec), we also
        abide by those laws, ensuring compliance with any additional or stricter requirements.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">14.3 Ontario Residential Tenancies Act Considerations:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        We handle Personal Information in a manner consistent with tenant protections from privacy intrusions and
        harassment under sections 22 and 23 of Ontario&rsquo;s Residential Tenancies Act, 2006.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">14.4 Other Provinces and Territories:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        In all other Canadian jurisdictions, our practices are intended to meet the requirements of PIPEDA.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">14.5 Ongoing and Future Compliance:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        We are committed to remaining compliant with any new or amended privacy legislation.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">14.6 International Expansion:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        If TrueTenant expands its Services beyond Canada, we will comply with all applicable data protection laws in
        those jurisdictions.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">15. GOVERNING LAW</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >This Privacy Policy and any disputes arising from it shall be governed by the laws of the Province of Ontario and
        the federal laws of Canada applicable therein.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">16. CONTACT INFORMATION</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If you have any questions, concerns, or requests regarding this Privacy Policy or how TrueTenant handles your
        Personal Information, please contact our designated Privacy Officer at </span
    ><a href="mailto:privacy@truetenant.ai" style="font-weight:500;font-size:14px;color:#32302F;">privacy@truetenant.ai</a
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">.</span>
</p>`
